import * as React from "react";
import { CheckCircleFilled } from "@ant-design/icons";

export interface RadioCardOption<T = string | boolean> {
  value: T;
  label: string;
  disabled?: boolean;
  boldLabel?: boolean;
  children?: React.ReactNode;
}

interface Props<T = string | boolean> {
  value: T;
  onChange: (value: T) => void;
  options: RadioCardOption<T>[];
  vertical?: boolean;
  grid?: boolean;
  gridCols?: number;
}

export function RadioCardGroup<T = string | boolean>(props: Props<T>): React.ReactElement {
  const { value, onChange, grid, gridCols = 2, vertical, options } = props;

  return (
    <div className={`gap-4 ${grid ? `grid grid-cols-${gridCols}` : `flex ${vertical ? "flex-col" : ""}`}`}>
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <div
            key={String(option.value)}
            className={`mb-2 p-4 border ${
              option.disabled ? "cursor-not-allowed radio-card-disabled" : "cursor-pointer"
            } radio-card ${isSelected ? "radio-card-active" : ""}`}
            style={{ minWidth: 100, borderRadius: 6 }}
            onClick={() => {
              if (option.disabled) {
                return;
              }
              onChange(option.value);
            }}
          >
            <div className="flex items-center gap-2">
              <div className={`${option.boldLabel ? "font-semibold" : ""}`}>{option.label}</div>
              {isSelected ? <CheckCircleFilled className="color-action h-4" /> : null}
            </div>
            {option.children}
          </div>
        );
      })}
    </div>
  );
}
